"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableV2 = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactTable = require("react-table");

var _reactFeather = require("react-feather");

var _reactScroll = require("react-scroll");

var _TableV = require("./TableV2.style");

var _helper = require("../../lib/utils/helper");

var _excluded = ["indeterminate"];

var TableV2 = function TableV2(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      sectionTitle = _ref.sectionTitle,
      setRowsToExport = _ref.setRowsToExport,
      resetRows = _ref.resetRows;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var navigate = (0, _reactRouterDom.useNavigate)();

  var params = _queryString.default.parse(searchParams.toString());

  var trimStr = function trimStr(str, delimiter) {
    if (typeof str !== 'string') return str;
    var _delimiter = '';

    if (typeof delimiter === 'string') {
      _delimiter = delimiter;
    }

    return str.split(/\s+/g).join(_delimiter);
  };

  var isMarked = function isMarked(id) {
    var rowId = params.rowId;

    if (rowId) {
      return trimStr(id) === trimStr(rowId);
    }

    var rowIds = (0, _helper.tryParseJson)(params.rowIds);

    if (rowIds !== null && rowIds !== void 0 && rowIds.length) {
      return rowIds.includes(id);
    }

    return false;
  };

  var _columns = (0, _react.useMemo)(function () {
    return columns.map(function (col) {
      return {
        Header: col,
        accessor: function accessor(row) {
          return row[col];
        }
      };
    });
  }, []);

  var _data = (0, _react.useMemo)(function () {
    return data;
  }, []);

  var _useTable = (0, _reactTable.useTable)({
    columns: _columns,
    data: _data,
    autoResetSelectedRows: true
  }, _reactTable.useSortBy, _reactTable.useResizeColumns, _reactTable.useRowSelect, _reactTable.useFlexLayout, function (hooks) {
    hooks.allColumns.push(function (columns) {
      return [// Let's make a column for selection
      {
        id: 'selection',
        disableResizing: true,
        minWidth: 31,
        width: 31,
        maxWidth: 31,
        Header: function Header(_ref2) {
          var getToggleAllRowsSelectedProps = _ref2.getToggleAllRowsSelectedProps;
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(IndeterminateCheckbox, getToggleAllRowsSelectedProps()));
        },
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: function Cell(_ref3) {
          var row = _ref3.row;
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(IndeterminateCheckbox, row.getToggleRowSelectedProps()));
        }
      }].concat((0, _toConsumableArray2.default)(columns));
    });
    hooks.useInstanceBeforeDimensions.push(function (_ref4) {
      var headerGroups = _ref4.headerGroups;
      // fix the parent group of the selection button to not be resizable
      var selectionGroupHeader = headerGroups[0].headers[0];
      selectionGroupHeader.canResize = false;
    });
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow,
      selectedFlatRows = _useTable.selectedFlatRows,
      toggleAllRowsSelected = _useTable.toggleAllRowsSelected;

  (0, _react.useEffect)(function () {
    var selectedRows = selectedFlatRows && selectedFlatRows.length && !resetRows ? selectedFlatRows.map(function (row) {
      return row.original;
    }) : [];
    setRowsToExport(function (prev) {
      if (!selectedRows.length) {
        return prev.filter(function (el) {
          return el.sectionTitle !== sectionTitle;
        });
      }

      var newArr = [];
      var newRowsData = {
        sectionTitle: sectionTitle,
        rows: selectedRows
      };
      var hasSection = prev.find(function (el) {
        return el.sectionTitle === newRowsData.sectionTitle;
      });

      if (prev.length && !hasSection) {
        newArr.push.apply(newArr, (0, _toConsumableArray2.default)(prev));
        newArr.push(newRowsData);
        return newArr;
      } else if (!prev.length && !hasSection) {
        newArr.push(newRowsData);
        return newArr;
      }

      prev.map(function (row) {
        if (row.sectionTitle === newRowsData.sectionTitle) {
          newArr.push({
            sectionTitle: row.sectionTitle,
            rows: newRowsData.rows
          });
        } else {
          newArr.push(row);
        }
      });
      return newArr;
    });

    if (resetRows) {
      toggleAllRowsSelected(false);
    }
  }, [selectedFlatRows, resetRows]);

  var IndeterminateCheckbox = /*#__PURE__*/_react.default.forwardRef(function (_ref5, ref) {
    var indeterminate = _ref5.indeterminate,
        rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded);

    var defaultRef = _react.default.useRef();

    var resolvedRef = ref || defaultRef;

    _react.default.useEffect(function () {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", Object.assign({
      type: "checkbox",
      ref: resolvedRef
    }, rest)));
  });

  var removeRowId = function removeRowId(id) {
    var isMarkedRow = isMarked(id);

    if (isMarkedRow) {
      var queryParams = new URLSearchParams(searchParams);
      queryParams.delete('rowId');
      queryParams.delete('rowIds');
      navigate({
        search: queryParams.toString()
      }, {
        replace: true
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TableV.TableWrapper, getTableProps(), /*#__PURE__*/_react.default.createElement("thead", null, headerGroups.map(function (headerGroup, i) {
    return /*#__PURE__*/_react.default.createElement("tr", Object.assign({
      key: "headerGroup".concat(i)
    }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/_react.default.createElement("th", Object.assign({
        key: "".concat(column.id).concat(i)
      }, column.getHeaderProps()), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", Object.assign({
        className: "header-content"
      }, column.getSortByToggleProps()), column.render('Header'), /*#__PURE__*/_react.default.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronDown, {
        size: 12
      })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronUp, {
        size: 12
      })) : '')), column.canResize && /*#__PURE__*/_react.default.createElement("div", Object.assign({}, column.getResizerProps(), {
        className: "resizer ".concat(column.isResizing ? 'isResizing' : '')
      }))));
    }));
  })), /*#__PURE__*/_react.default.createElement("tbody", getTableBodyProps(), rows.map(function (row, rowIndex) {
    prepareRow(row);
    var rowId = (0, _helper.generateRowId)(row.values);
    return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
      key: rowId,
      name: rowId
    }, /*#__PURE__*/_react.default.createElement("tr", Object.assign({}, row.getRowProps(), {
      className: "".concat(isMarked(rowId) ? 'isMarked' : '', " ").concat(row.isSelected ? 'selected' : ''),
      onClick: function onClick() {
        return removeRowId(rowId);
      }
    }), row.cells.map(function (cell) {
      return /*#__PURE__*/_react.default.createElement("td", cell.getCellProps(), cell.render('Cell'));
    })));
  }))));
};

exports.TableV2 = TableV2;